import { useCallback } from 'react';
import { useApi, fetchApiRef } from '@backstage/frontend-plugin-api';
import { tracksResponseSchema } from '../schemas/tracks';
import {
  PULSE_CACHE_KEYS,
  PULSE_QUERY_CACHE_POLICIES,
  useCachedQuery,
} from './cache';

type UsePulseTracksOptions = {
  enabled?: boolean;
  cache?: boolean;
};

export const usePulseTracks = ({
  enabled = true,
  cache = true,
}: UsePulseTracksOptions = {}) => {
  const { fetch } = useApi(fetchApiRef);

  const fetchTracks = useCallback(async () => {
    const response = await fetch('plugin://pulse/tracks');

    if (!response.ok) {
      throw new Error(
        `Failed to fetch tracks: ${response.status} ${response.statusText}`,
      );
    }

    const data = await response.json();
    const parsed = tracksResponseSchema.parse(data);

    return parsed.tracks;
  }, [fetch]);

  return useCachedQuery({
    cacheKey: PULSE_CACHE_KEYS.tracks,
    fetcher: fetchTracks,
    ...PULSE_QUERY_CACHE_POLICIES.definitions,
    enabled,
    useSharedCache: cache,
  });
};
